import { useMemo } from "react";
import { Redirect, Route, useLocation, Switch } from "react-router-dom";
import {
  IonTabs,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonIcon,
  IonLabel,
  IonBadge,
} from "@ionic/react";
import {
  bulbOutline,
  todayOutline,
  settingsOutline,
  notificationsOutline,
} from "ionicons/icons";

import BrainDumpPage from "../pages/BrainDumpPage";
import TodayPage from "../pages/TodayPage";
import TaskDetailPage from "../pages/TaskDetailPage";
import SettingsPage from "../pages/SettingsPage";
import RecurringPage from "../pages/RecurringPage";
import TriagePage from "../pages/TriagePage";
import { useStore } from "../store/useStore";
import { selectStaleTasks } from "../lib/stale";

export default function TabsLayout() {
  const location = useLocation();
  const tasks = useStore((s) => s.tasks);
  const staleCount = useMemo(() => selectStaleTasks(tasks).length, [tasks]);

  return (
    <IonTabs>
      <IonRouterOutlet>
        <Switch>
          <Route path="/dump" exact component={BrainDumpPage} />
          <Route path="/today" exact component={TodayPage} />
          <Route path="/triage" exact component={TriagePage} />
          <Route path="/tasks/:taskId" exact component={TaskDetailPage} />
          <Route path="/recurring" exact component={RecurringPage} />
          <Route path="/settings" exact component={SettingsPage} />
          <Route path="/" exact>
            <Redirect to="/today" />
          </Route>
        </Switch>
      </IonRouterOutlet>

      <IonTabBar slot="bottom">
        <IonTabButton
          tab="dump"
          href="/dump"
          selected={location.pathname === "/dump"}
        >
          <IonIcon icon={bulbOutline} />
          <IonLabel>Dump</IonLabel>
        </IonTabButton>

        <IonTabButton
          tab="today"
          href="/today"
          selected={location.pathname === "/today"}
        >
          <IonIcon icon={todayOutline} />
          <IonLabel>Today</IonLabel>
        </IonTabButton>

        <IonTabButton
          tab="triage"
          href="/triage"
          selected={location.pathname === "/triage"}
        >
          <IonIcon icon={notificationsOutline} />
          <IonLabel>Triage</IonLabel>
          {staleCount > 0 && <IonBadge color="danger">{staleCount}</IonBadge>}
        </IonTabButton>

        <IonTabButton
          tab="settings"
          href="/settings"
          selected={location.pathname.startsWith("/settings")}
        >
          <IonIcon icon={settingsOutline} />
          <IonLabel>Settings</IonLabel>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  );
}
